import React, { PropsWithChildren, useEffect } from 'react';
import { StompSessionProvider } from 'react-stomp-hooks';
import SecurityService from '@app/model/_security/service/SecurityService';
import useSiteState from '@app/state/SiteState';


const WebSocketWrapper: React.FunctionComponent<PropsWithChildren<{}>> = ({ children }) => {

	const principal = useSiteState(state => state.principal);

	return !!principal ? <StompSessionProvider
		url={`${process.env.REACT_APP_API_URL}/ws?token=${SecurityService.getToken()}`}
		connectHeaders={
			{
				authorization: `Bearer ${SecurityService.getToken()}`,
			}
		}
		debug={(str) => {
			// console.log(str);
		}}
		onStompError={(e) => {
			console.error(e);
		}}>
		{children}
	</StompSessionProvider> : children;
};

export default WebSocketWrapper;